import { Component, SVGProps } from 'react';
import SVG from '.';
interface SVGIconUncheckProps extends SVGProps<any> {}
export class SVGIconUncheck extends Component<SVGIconUncheckProps> {
  render() {
    const { width = 24, height = 24, color = '#4A5568', ...rest } = this.props;
    return (
      <SVG
        className="svg-icon-check"
        width={`${width}`}
        height={`${height}`}
        viewBox={`0 0 ${width} ${height}`}
        {...rest}
      >
        <path
          fill="rgb(204, 30, 123)"
          d="M15.0605,12.9395a1.5,1.5,0,1,1-2.1211,2.1211L8,10.1211,3.0605,15.0605A1.5,1.5,0,0,1,.9395,12.9395L5.8789,8,.9395,3.0605A1.5,1.5,0,0,1,3.0605.9395L8,5.8789,12.9395.9395a1.5,1.5,0,0,1,2.1211,2.1211L10.1211,8Z"
          transform="scale(1.3)"
        />
      </SVG>
    );
  }
}
